import { useGetPublicProductGroupsQuery } from 'pricing-pages-ui-public-app/__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc.hooks';
import { useMemo } from 'react';
import { DEFAULT_CHIRP_TIMEOUT } from '../constants/chirpDefaults';
import { useCurrency } from '../context/CurrencyContext';
import { isCountryCodeString } from '../utils/currencyTypes';
import { getBrowserLocale, getCountryCode } from '../utils/getPreferredLanguage';
import { buildPricingPageViewModel } from '../utils/buildPricingPageViewModel';
import { getProductGroupSkeletonCount } from '../utils/getProductGroupSkeletonCount';
const EMPTY_CARDS = [];
const EMPTY_STANDALONE = [];
const EMPTY_SCHEMA_PRODUCTS = [];
export function usePublicProductGroupsData(productGroup, opts) {
  var _viewModel$cards, _viewModel$cardCount, _viewModel$standalone, _viewModel$schemaProd, _viewModel$currencyCo, _viewModel$hasStarter;
  const {
    selectedTerm,
    isEnterpriseTier
  } = opts;
  const {
    displayedCurrencyCode
  } = useCurrency();
  const browserLocale = useMemo(() => getBrowserLocale(), []);
  const rawCountryCode = useMemo(() => getCountryCode(), []);
  const preferredCountry = useMemo(() => isCountryCodeString(rawCountryCode) ? rawCountryCode : undefined, [rawCountryCode]);
  const {
    data,
    error
  } = useGetPublicProductGroupsQuery({
    variables: {
      productGroup,
      currencyCode: displayedCurrencyCode,
      preferredCountry,
      browserLocale
    },
    context: {
      timeout: DEFAULT_CHIRP_TIMEOUT
    }
  });
  const viewModel = useMemo(() => {
    if (!data) return null;
    return buildPricingPageViewModel(data, {
      selectedTerm,
      isEnterpriseTier,
      displayedCurrencyCode
    });
  }, [data, selectedTerm, isEnterpriseTier, displayedCurrencyCode]);
  let status = 'loading';
  if (error) {
    status = 'error';
  } else if (data) {
    status = 'ready';
  }
  return {
    rawData: data,
    status,
    error,
    cards: (_viewModel$cards = viewModel === null || viewModel === void 0 ? void 0 : viewModel.cards) !== null && _viewModel$cards !== void 0 ? _viewModel$cards : EMPTY_CARDS,
    cardCount: (_viewModel$cardCount = viewModel === null || viewModel === void 0 ? void 0 : viewModel.cardCount) !== null && _viewModel$cardCount !== void 0 ? _viewModel$cardCount : isEnterpriseTier ? 2 : getProductGroupSkeletonCount(productGroup),
    standaloneProducts: (_viewModel$standalone = viewModel === null || viewModel === void 0 ? void 0 : viewModel.standaloneProducts) !== null && _viewModel$standalone !== void 0 ? _viewModel$standalone : EMPTY_STANDALONE,
    schemaProducts: (_viewModel$schemaProd = viewModel === null || viewModel === void 0 ? void 0 : viewModel.schemaProducts) !== null && _viewModel$schemaProd !== void 0 ? _viewModel$schemaProd : EMPTY_SCHEMA_PRODUCTS,
    currencyCode: (_viewModel$currencyCo = viewModel === null || viewModel === void 0 ? void 0 : viewModel.currencyCode) !== null && _viewModel$currencyCo !== void 0 ? _viewModel$currencyCo : displayedCurrencyCode,
    starterApiName: viewModel === null || viewModel === void 0 ? void 0 : viewModel.starterApiName,
    professionalApiName: viewModel === null || viewModel === void 0 ? void 0 : viewModel.professionalApiName,
    enterpriseApiName: viewModel === null || viewModel === void 0 ? void 0 : viewModel.enterpriseApiName,
    hasStarterTier: (_viewModel$hasStarter = viewModel === null || viewModel === void 0 ? void 0 : viewModel.hasStarterTier) !== null && _viewModel$hasStarter !== void 0 ? _viewModel$hasStarter : false
  };
}